import { put } from 'redux-saga/effects';

import { IKnmDictionary } from 'APIPackage/KnmModule/interfaces/IKnmDictionary';
import { dictionariesItemValueGet } from 'CorePackage/DictionariesModule/actions/dictionariesActions';

export function* getDictionariesItemValue(value: IKnmDictionary) {
  yield put(dictionariesItemValueGet(value.dictId, value.dictVersionId));
}
